import React, {PureComponent, KeyboardEvent, ChangeEvent, CSSProperties} from 'react'
import TinyDatePicker from 'tiny-date-picker'
import './DatePicker.css'
import cxs from 'cxs/component'
import Theme, {mediaQueries} from 'Theme'
import {lang} from 'helpers/i18n'
import {Input} from 'elements'

interface Props {
  name: string
  hora: {hours: number, minutes: number}
  onChange(name: string, value: {}) : void
  onKeyPress?(charCode: number): void
}

interface State {
  hours: string
  minutes: string
}

export default class extends PureComponent<Props, State> {
  id = `datepicker-${this.props.name}`
  state: State

  constructor(props: Props) {
    super(props)
    const date = new Date()
    this.state = {
      hours: this.ceros(this.props.hora.hours),
      minutes: this.ceros(this.props.hora.minutes)
    }
    // console.log(this.id)
  }

  handleHourChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (Number(event.target.value) < 24 && Number(event.target.value) >= 0) {
      this.setState({hours: event.target.value},
        () => this.props.onChange('hora', {hours: this.state.hours, minutes: this.state.minutes})
      )
    }

  }

  handleMinutesChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (Number(event.target.value) < 60 && Number(event.target.value) >= 0) {
      this.setState({minutes: event.target.value},
        () => this.props.onChange('hora', {hours: this.state.hours, minutes: this.state.minutes})
      )
    }

  }

  handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    console.log('event.keyCode', event.keyCode)
    console.log('event', event)
    if (event.keyCode === 13 || event.keyCode === 9) {
      this.setState(prev => {
        return {
          hours: this.ceros(Number(prev.hours)),
          minutes: this.ceros(Number(prev.minutes)),
        }
      })
    }
  }

  ceros = (value: number) => {
    if (value > 9) {
      return String(value)
    }
    return '0'.concat(String(value))
  }

  render() {
    const {name, onChange, onKeyPress, ...props} = this.props
    const {hours, minutes} = this.state
    return (
      <div {...props}>
        <TimePicker>
          <TimeInput>
            <Input
              type="number"
              label={'hora'}
              value={hours}
              min={0}
              max={23}
              onKeyDown={this.handleKeyDown}
              /*onKeyPress={this.handleClick}*/
              onChange={this.handleHourChange}
            />
          </TimeInput>
          <TimeInput>
            <Input
              type="number"
              label={'minutos'}
              value={String(minutes)}
              min={0}
              max={59}
              onKeyDown={this.handleKeyDown}
              onChange={this.handleMinutesChange}
            />
          </TimeInput>
        </TimePicker>
      </div>
    )
  }
}

const TimePicker = cxs('div')({
  padding: Theme.size.space[1],
  textAlign: 'center',
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  [mediaQueries.desktop]: {
    border: 0,
    outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
  }
} as CSSProperties)

const TimeInput = cxs('div')({
  width: '4em',
  margin: `0 ${Theme.size.space[1]}`,
  display: 'inline-block'
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/TimePicker.tsx